(function($) {
    'use strict';

    $(document).ready(function() {
        // Initialize Slick Slider
        $('.video-slider').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        // Helper to detect video ID and type (youtube/vimeo) from URL or ID
        function detectVideo(input) {
            if (!input) return { id: '', type: '' };
            input = input.toString().trim();
            
            // Vimeo URL
            var vimeoMatch = input.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)([0-9]+)/i);
            if (vimeoMatch) {
                return { id: vimeoMatch[1], type: 'vimeo' };
            }
            if (/^[0-9]+$/.test(input)) {
                return { id: input, type: 'vimeo' };
            }
            
            // YouTube URL
            var youtubeMatch = input.match(/(?:youtube(?:-nocookie)?\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
            if (youtubeMatch) {
                return { id: youtubeMatch[1], type: 'youtube' };
            }
            
            // Fallback
            return { id: input, type: 'youtube' };
        }

        // Inline Video Player Handler
        $('.video-card').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            
            var $card = $(this);
            var videoInput = $card.data('video-id') || $card.attr('data-video-id');
            if (!videoInput) return;

            var videoInfo = detectVideo(videoInput);
            var videoId = videoInfo.id;
            var videoType = $card.data('video-type') || $card.attr('data-video-type') || videoInfo.type;

            var iframeSrc = "";
            if (videoType === 'vimeo') {
                iframeSrc = "https://player.vimeo.com/video/" + videoId + "?autoplay=1&dnt=1";
            } else {
                iframeSrc = "https://www.youtube.com/embed/" + videoId + "?autoplay=1&modestbranding=1&rel=0&playsinline=1&enablejsapi=1";
            }

            var $iframe = $('<iframe>', {
                src: iframeSrc,
                frameborder: "0",
                allow: "autoplay; encrypted-media; fullscreen",
                allowfullscreen: true,
                draggable: "false"
            }).css({
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                border: 'none',
                zIndex: '3'
            });

            $card.empty().append($iframe);
            $card.removeClass('video-card').css('cursor', 'default');
        });
    });

})(jQuery);
